export function invariant(condition, message, Err = Error) {
    if (!condition) {
        throw new Err(message);
    }
}
